<div class="div_loading">
    <div class="my-container" [hidden]="!loading">
        <mat-progress-bar mode="indeterminate"></mat-progress-bar>
    </div>
</div>

<div class="row" style="direction: rtl;display: flex !important;">
    <div class="col-xl-2 col-lg-2 col-md-3 col-sm-4 col-xs-12 padding0">
        <input class="search_box" name="search_all" [(ngModel)]="search_all" (keyup)="check_access(4,1,'',1,2)"
            placeholder="جستجو..." autocomplete="off" style="width:100%">
    </div>
    <div class="col-xl-8 col-lg-8 col-md-7 col-sm-8 col-xs-12 padding0">
        <div [ngStyle]="{'direction' : lang == 2 ? 'ltr' : 'rtl'}" class="service_pager">
            <span>
                <button (click)='open_detaile(0,3,0)' *ngIf="lang == 1" class="search1">جستجو</button>
                <button (click)='open_detaile(0,3,0)' *ngIf="lang == 2" [ngClass]="{en_navigation_number:lang==2}"
                    class="search1">Search</button>
                <a id="download" href="{{ site }}/export/{{ export_code }}.xlsx" *ngIf="show_excel == true">
                    <button [ngClass]="{en_navigation_number:lang==2}">
                        <span *ngIf="lang == 2">Excel</span>
                        <span *ngIf="lang == 1">خروجی اکسل</span>
                    </button>
                </a>
                <button (click)="check_access(4,4,0,1,1)" [disabled]='next_status'><i
                        class="fas fa-fast-forward"></i></button>
                <button (click)="check_access(4,2,0,1,1)" [disabled]='next_status'><i
                        class="fas fa-forward"></i></button>
                <button (click)="check_access(4,3,0,1,1)" [disabled]='pre_status'><i
                        class="fas fa-backward"></i></button>
                <button (click)="check_access(4,5,0,1,1)" [disabled]='pre_status'><i
                        class="fas fa-fast-backward"></i></button>
                <div class='navigation' [ngClass]="{en_navigation_number:lang==2}"><span> {{ page_number_first }}
                    </span><span>-</span><span> {{ page_number_second }} </span><span> of </span><span>
                        {{ count_total }} </span>
                </div>
            </span>
        </div>
    </div>
    <div class="col-xl-2 col-lg-2 col-md-2 col-sm-6 col-xs-12 padding0 hidden-sm hidden-xs" [hidden]="true">
        <div class="pager_checkbox">
            <div class="material-icons pager_icons cursor" (click)="check_access(3,0,selected_record,1,1)">
                delete
            </div>
            <div style="display: inline-block;">
                <mat-checkbox (change)="get_select($event.checked)" [(indeterminate)]="indeterminate"></mat-checkbox>
            </div>
        </div>
    </div>
</div>

<div class="content-body control-content-body" [ngClass]="{content_body_en:lang==2}"
    style='overflow-x:auto;direction:rtl;' (window:resize)="change_resize()">
    <mat-table [dataSource]="dataSource" style='min-width:100%' class='table-scroll mat_table_fa_without_scroll pe1'
        [ngClass]="{mat_table_en_without_scroll:lang==2,en1:lang == 2}"
        [ngStyle]="{'direction': lang == 2 ? 'ltr' : 'rtl' }">
        <ng-container matColumnDef="row">
            <mat-header-cell *matHeaderCellDef style='max-width:40px'>
                <span *ngIf="lang == 1">ردیف</span>
                <span *ngIf="lang == 2">#</span>
            </mat-header-cell>
            <mat-cell *matCellDef="let x;let i = index" style='max-width:40px'>{{ i + page_number_first }}</mat-cell>
        </ng-container>

        <ng-container matColumnDef="date">
            <mat-header-cell *matHeaderCellDef style="max-width:90px">
                <span *ngIf="lang == 1">تاریخ</span>
                <span *ngIf="lang == 2">Title</span>
            </mat-header-cell>
            <mat-cell *matCellDef="let x;let i = index" style="max-width:90px;direction: rtl;">
                <div>{{x.date}}</div>
            </mat-cell>
        </ng-container>

        <ng-container matColumnDef="material_id">
            <mat-header-cell *matHeaderCellDef style="max-width:90px">
                <span *ngIf="lang == 1">شناسه کالا</span>
                <span *ngIf="lang == 2">---</span>
            </mat-header-cell>
            <mat-cell *matCellDef="let x;let i = index" style="max-width:90px;direction: rtl;">
                {{x.wharehouse_material_id }}
            </mat-cell>
        </ng-container>

        <ng-container matColumnDef="material_title">
            <mat-header-cell *matHeaderCellDef style="min-width: 300px;">
                <span *ngIf="lang == 1">نام کالا</span>
                <span *ngIf="lang == 2">---</span>
            </mat-header-cell>
            <mat-cell *matCellDef="let x;let i = index" style="min-width: 300px;">
                <div class="right">{{x.wharehouse_material_title }}</div>
            </mat-cell>
        </ng-container>

        <ng-container matColumnDef="type_title">
            <mat-header-cell *matHeaderCellDef style="max-width:110px">
                <span *ngIf="lang == 1">نوع گردش</span>
                <span *ngIf="lang == 2">---</span>
            </mat-header-cell>
            <mat-cell *matCellDef="let x;let i = index" style="max-width:110px">
                {{x.type_title }}
            </mat-cell>
        </ng-container>

        <ng-container matColumnDef="order_id">
            <mat-header-cell *matHeaderCellDef style="max-width:90px">
                <span *ngIf="lang == 1">شناسه گردش</span>
                <span *ngIf="lang == 2">---</span>
            </mat-header-cell>
            <mat-cell *matCellDef="let x;let i = index" style="max-width:90px">
                {{x.id }}
            </mat-cell>
        </ng-container>

        <ng-container matColumnDef="user">
            <mat-header-cell *matHeaderCellDef>
                <span *ngIf="lang == 1">نام طرف حساب</span>
                <span *ngIf="lang == 2">---</span>
            </mat-header-cell>
            <mat-cell *matCellDef="let x;let i = index">
                <div class="right">{{x.user_title }}</div>
            </mat-cell>
        </ng-container>

        <ng-container matColumnDef="imported">
            <mat-header-cell *matHeaderCellDef style="max-width:60px">
                <span *ngIf="lang == 1">وارده</span>
                <span *ngIf="lang == 2">---</span>
            </mat-header-cell>
            <mat-cell *matCellDef="let x;let i = index" style="max-width:60px">
                {{x.imported }}
            </mat-cell>
        </ng-container>

        <ng-container matColumnDef="exited">
            <mat-header-cell *matHeaderCellDef style="max-width:60px">
                <span *ngIf="lang == 1">صادره</span>
                <span *ngIf="lang == 2">---</span>
            </mat-header-cell>
            <mat-cell *matCellDef="let x;let i = index" style="max-width:60px">
                {{x.exited }}
            </mat-cell>
        </ng-container>

        <ng-container matColumnDef="remain">
            <mat-header-cell *matHeaderCellDef style="max-width:60px">
                <span *ngIf="lang == 1">مانده</span>
                <span *ngIf="lang == 2">---</span>
            </mat-header-cell>
            <mat-cell *matCellDef="let x;let i = index" style="max-width:60px">
                {{ x.remain }}
            </mat-cell>
        </ng-container>

        <ng-container matColumnDef="price">
            <mat-header-cell *matHeaderCellDef style="max-width:90px">
                <span *ngIf="lang == 1">قیمت واحد</span>
                <span *ngIf="lang == 2">Inventory</span>
            </mat-header-cell>
            <mat-cell *matCellDef="let x;let i = index" style="max-width:90px"
                (click)="open_report(x.wharehouse_material_id)">
                {{ x.price | number }}
            </mat-cell>
        </ng-container>


        <ng-container matColumnDef="sum">
            <mat-header-cell *matHeaderCellDef style="max-width:90px">
                <span *ngIf="lang == 1">جمع کل</span>
                <span *ngIf="lang == 2">Sum</span>
            </mat-header-cell>
            <mat-cell *matCellDef="let x;let i = index" style="max-width:90px"
                (click)="open_report(x.wharehouse_material_id)">
                {{ x.sum | number }}
            </mat-cell>
        </ng-container>



        <ng-container matColumnDef="id">
            <mat-header-cell *matHeaderCellDef>
                <span *ngIf="lang == 1"> شناسه </span>
                <span *ngIf="lang == 2">Id</span>
            </mat-header-cell>
            <mat-cell *matCellDef="let x;let i = index">{{
                x.wharehouse_order_id }}</mat-cell>
        </ng-container>100px

        <ng-container matColumnDef="operation">
            <mat-header-cell *matHeaderCellDef style='max-width:100px' [hidden]="true">
                <span *ngIf="lang == 1"> عملیات </span>
                <span *ngIf="lang == 2">Operation</span>
            </mat-header-cell>
            <mat-cell *matCellDef="let x;let i = index" style='max-width:100px' [hidden]="true">
                <mat-checkbox (change)="get_select_records(i)" name="selete_records[]"
                    [value]="x.wharehouse_material_id" [checked]="x.checked" class="hidden-sm hidden-xs"></mat-checkbox>
                <span><i class="fas fa-desktop icon"></i></span>
                <span (click)="check_access(3,0,x.wharehouse_material_id,0,1)"><i class="far fa-trash-alt icon"
                        style='margin:0px 4px;'></i></span>
            </mat-cell>
        </ng-container>

        <mat-header-row class="mat-header-row-dialog" *matHeaderRowDef="displayedColumns" color="primary">
        </mat-header-row>
        <mat-row class="mat-header-row-dialog" *matRowDef="let row;columns:displayedColumns;let i = index"
            (click)="mat_table_selectedRow = row" (mouseenter)="mat_table_hoverRow = row"
            [ngClass]="{'mat_table_selected': row === mat_table_selectedRow,mat_table_selected2:row.checked == true,'mat_table_hover': row === mat_table_hoverRow}"
            class="cursor"></mat-row>

    </mat-table>

    <div class="row" class="preview1" [hidden]="count_total > 0">
        <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12">
            <div>
                <img src="../../../assets/images/preview.png">
            </div>
            <div class="preview2" *ngIf="lang == 1">هیچ رکوردی برای نمایش وجود ندارد</div>
            <div class="preview2" *ngIf="lang == 2">There are no records to display</div>
        </div>
    </div>
</div>